/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface ValuePropItem {
  icon: ReactNode
  title: string
  text: string
  span?: boolean
}

export interface ValuePropsProps {
  items: ValuePropItem[]
}

export function ValueProps({ items }: ValuePropsProps) {
  return (
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-6 md:grid-cols-2 lg:grid-cols-4">
      {items.map((item) => (
        <div
          className={cn(
            'rounded-xl border bg-card p-8 transition-colors hover:border-primary',
            item.span && 'lg:col-span-2'
          )}
          key={item.title}
        >
          {item.span ? (
            <div className="flex items-start gap-6">
              <div className="shrink-0 text-primary [&_svg]:size-6 md:[&_svg]:size-7">{item.icon}</div>
              <div>
                <h3 className="mb-4 font-bold text-foreground text-xl uppercase tracking-tighter">{item.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{item.text}</p>
              </div>
            </div>
          ) : (
            <>
              <div className="mb-6 text-primary [&_svg]:size-6 md:[&_svg]:size-7">{item.icon}</div>
              <h3 className="mb-4 font-bold text-foreground text-xl uppercase tracking-tighter">{item.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{item.text}</p>
            </>
          )}
        </div>
      ))}
    </div>
  )
}
